import http from '@/http'
import { serializeObjectToQueryParameter } from '@/store/helper'

const API_PATH = 'user/account/reserved_room/'

const state = {
  reservedRoomIdStatus: ''
}

const getters = {
  reservedRoomIdStatus: state => state.reservedRoomIdStatus
}

const mutations = {
  reservedRoomIdStatus(state, payload) {
    state.reservedRoomIdStatus = payload
  }
}

const actions = {
  async check({ commit }, payload) {
    await http.get(API_PATH + 'check' + serializeObjectToQueryParameter(payload)).then(response => {
      commit('reservedRoomIdStatus', response.data.roomIdStatus)
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async update({ commit }, payload) {
    const params = JSON.stringify({
      reservedRoom: payload
    })
    await http.put(API_PATH, params).then(() => {
      commit('setHttpSuccess', '専用会議室名の変更が完了しました。', { root: true })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
